export default "__VITE_ASSET__DX7TPB6I__"